import { useEffect, useMemo, useState } from 'react';
import './RotatingText.css';

const RotatingText = ({
  texts = [],
  rotationInterval = 2000,
  mainClassName = '',
  prefix = '',
  splitBy = 'characters',
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (texts.length <= 1) return undefined;

    const intervalId = setInterval(() => {
      setCurrentIndex((index) => (index + 1) % texts.length);
    }, rotationInterval);

    return () => clearInterval(intervalId);
  }, [texts.length, rotationInterval]);

  const currentText = texts[currentIndex] || '';
  const parts = useMemo(() => {
    if (splitBy === 'words') {
      return currentText.split(' ');
    }

    if (splitBy === 'lines') {
      return currentText.split('\n');
    }

    if (typeof Intl !== 'undefined' && Intl.Segmenter) {
      const segmenter = new Intl.Segmenter('es', { granularity: 'grapheme' });
      return Array.from(segmenter.segment(currentText), (segment) => segment.segment);
    }

    return Array.from(currentText);
  }, [currentText, splitBy]);

  return (
    <span className={`rotating-text ${mainClassName}`.trim()}>
      {prefix ? <span className="rotating-text-prefix">{prefix}</span> : null}
      <span className="rotating-text-window" aria-live="polite">
        <span className="rotating-text-sr-only">{currentText}</span>
        <span className="rotating-text-item" key={currentText} aria-hidden="true">
          {parts.map((part, index) => (
            <span
              className="rotating-text-part"
              key={`${part}-${index}`}
              style={{ '--rotate-delay': `${index * 28}ms` }}
            >
              {part === ' ' ? '\u00a0' : part}
            </span>
          ))}
        </span>
      </span>
    </span>
  );
};

export default RotatingText;
